import { useContext, useEffect, useRef } from 'react';
import { useSaveMomentSettings, useMyMoments } from '../../api/moments';
import { MAX_SEEN_MOMENTS, MomentContext, markSeenLocally, seenLocally } from './moments';
import { pickMoment } from './reviewMoments';

/**
 * Fires the one moment the server's facts allow now, at most ONCE per person per fact id, and never
 * when the person switched moments off. Renders nothing.
 *
 * Nothing is decided before the facts AND settings have loaded — they arrive together in one response,
 * so firing on partial state cannot happen: no data, no moment.
 */
export default function MomentsWatcher() {
  const { show } = useContext(MomentContext);
  const { data } = useMyMoments();
  const { mutate: save } = useSaveMomentSettings();
  const fired = useRef(new Set<string>());

  useEffect(() => {
    // The facts and the settings arrive in ONE response, so "loaded" is simply "data is here"; the
    // off switch and the seen record are pickMoment's to apply (one place, tested there).
    if (!data?.available) return;
    const pick = pickMoment(data);
    if (!pick) return;
    const { moment, alsoSeen } = pick;
    if (fired.current.has(moment.id) || seenLocally(moment.id)) return;

    fired.current.add(moment.id);
    const ids = [moment.id, ...alsoSeen];
    markSeenLocally(ids);
    show(moment);
    save({ seen: [...data.seen, ...ids].slice(-MAX_SEEN_MOMENTS) });
  }, [data, show, save]);

  return null;
}
